<template>
  <component
    :is="partnerLogo"
    v-if="partnerLogo"
    class="PartnerLogo"
    @click="$emit('click')"
  />
</template>
<script>
import { defineAsyncComponent } from 'vue'

const BancoBrasilLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/bb.svg?component'),
)
const BancoPanLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/bancopan.svg?component'),
)
const BancoParanaLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/parana_banco.svg?component'),
)
const BpcLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/bompracredito.svg?component'),
)
const BvLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/bv.svg?component'),
)
const BizLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/biz.svg?component'),
)
const BxLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/bx.svg?component'),
)
const CredihomeLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/credihome.svg?component'),
)
const CreditasLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/creditas.svg?component'),
)
const LivreLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/livredigital.svg?component'),
)
const NoverdeLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/noverde.svg?component'),
)
const PortocredLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/portocred.svg?component'),
)
const ProvuLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/provu.svg?component'),
)
const RebelLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/geru.svg?component'),
)
const SimLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/sim.svg?component'),
)
const SimplicLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/simplic.svg?component'),
)
const SuperSimLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/supersim.svg?component'),
)
const ItauLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/itau.svg?component'),
)
const JeittoLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/jeitto.svg?component'),
)
const AgilLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/agil.svg?component'),
)
const ItiLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/iti.svg?component'),
)
const PicpayLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/picpay.svg?component'),
)
const PortoSeguroLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/portoseguro.svg?component'),
)
const WillbankLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/willbank.svg?component'),
)
const SantanderLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/santander.svg?component'),
)
const BrasilCardLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/brasilcard.svg?component'),
)
const NeonLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/neon.svg?component'),
)
const CrefazLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/crefaz.svg?component'),
)
const JbcredLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/jbcred.svg?component'),
)
const JuvoLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/juvo.svg?component'),
)
const HCredLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/hcred.svg?component'),
)
const CronosLogo = defineAsyncComponent(
  () => import('@/aasgard/assets/img/icons/ico-cronos.svg?component'),
)
const UppLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/upp.svg?component'),
)
const SegueLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/segue.svg?component'),
)
const BlipayLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/blipay.svg?component'),
)
const FlowCrediLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/flowcredi.svg?component'),
)
const ConexaoFinanceiraLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/conexaofinanceira.svg?component'),
)
const ZippiLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/zippi.svg?component'),
)
const KoinLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/koin.svg?component'),
)
const ZilicredLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/zilicred.svg?component'),
)
const OmniLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/omni.svg?component'),
)
const DeutopLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/deutop.svg?component'),
)
const JbmockLogo = defineAsyncComponent(
  () => import('@/assets/images/logos/loan/jbmock.svg?component'),
)
const MenosJurosLogo = defineAsyncComponent(
  () => import('@/aasgard/assets/img/icons/ico-menos_juros.svg?component'),
)
export default {
  name: 'PartnerLogo',
  components: {
    // logos
    BancoBrasilLogo,
    BancoPanLogo,
    BancoParanaLogo,
    BpcLogo,
    BvLogo,
    BizLogo,
    BxLogo,
    CredihomeLogo,
    CreditasLogo,
    LivreLogo,
    NoverdeLogo,
    PortocredLogo,
    ProvuLogo,
    RebelLogo,
    SimLogo,
    SimplicLogo,
    SuperSimLogo,
    ItauLogo,
    JeittoLogo,
    AgilLogo,
    ItiLogo,
    PicpayLogo,
    PortoSeguroLogo,
    WillbankLogo,
    SantanderLogo,
    BrasilCardLogo,
    NeonLogo,
    CrefazLogo,
    JbcredLogo,
    JuvoLogo,
    HCredLogo,
    UppLogo,
    SegueLogo,
    BlipayLogo,
    FlowCrediLogo,
    ConexaoFinanceiraLogo,
    ZippiLogo,
    KoinLogo,
    ZilicredLogo,
    OmniLogo,
    DeutopLogo,
    CronosLogo,
    JbmockLogo,
    MenosJurosLogo,
  },
  props: {
    partnerId: { type: [Number, String], default: '' },
  },
  emits: ['click'],
  data() {
    return {
      partnersLogo: {
        NOVERDE: 'NoverdeLogo',
        SIMPLIC: 'SimplicLogo',
        REBEL: 'RebelLogo',
        GERU: 'RebelLogo',
        PORTOCRED: 'PortocredLogo',
        CREDITAS: 'CreditasLogo',
        OMNI: 'OmniLogo',
        BV: 'BvLogo',
        BV_FGTS: 'BvLogo',
        BANCOPAN: 'BancoPanLogo',
        EMPRESTIMO_SIM: 'SimLogo',
        BANCO_DO_BRASIL: 'BancoBrasilLogo',
        SUPERSIM: 'SuperSimLogo',
        PROVU: 'ProvuLogo',
        CREDIHOME: 'CredihomeLogo',
        ITAU: 'ItauLogo',
        JEITTO: 'JeittoLogo',
        AGIL: 'AgilLogo',
        WILLBANK: 'WillbankLogo',
        SANTANDER: 'SantanderLogo',
        BRASILCARD: 'BrasilCardLogo',
        NEON: 'NeonLogo',
        ITI: 'ItiLogo',
        PORTO_SEGURO: 'PortoSeguroLogo',
        PICPAY: 'PicpayLogo',
        CREFAZ: 'CrefazLogo',
        JBCRED: 'JbcredLogo',
        JUVO: 'JuvoLogo',
        HCRED: 'HCredLogo',
        UPP: 'UppLogo',
        BLIPAY: 'BlipayLogo',
        FLOWCREDI: 'FlowCrediLogo',
        CONEXAO_FINANCEIRA: 'ConexaoFinanceiraLogo',
        ZILICRED: 'ZilicredLogo',
        ZIPPI: 'ZippiLogo',
        KOIN: 'KoinLogo',
        SEGUE: 'SegueLogo',
        DEUTOP: 'DeutopLogo',
        CRONOS: 'CronosLogo',
        JBMOCK: 'JbmockLogo',
        MENOS_JUROS: 'MenosJurosLogo',
      },
    }
  },
  computed: {
    partnerLogo() {
      return this.partnersLogo[this.partnerId] || null
    },
  },
}
</script>
<style lang="scss">
.PartnerLogo {
  max-width: 56px;
  max-height: 56px;
}
</style>
